import React, { useEffect, useState } from 'react';
import Select from "react-select";
import PaginationComponent from '../pagination';

function OtpController() {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');
    const [list, setList] = useState([]);
    const [filterList, setFilterList] = useState([...list]);

    const item = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/otp/getOTPList`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setList(getRes.responsePacket);
                setFilterList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, "error in otp api");
        }
    };
    useEffect(() => {
        item();
    }, []);
    const [currentPage, setCurrentPage] = useState(1);

    // PAGINATION LOGIC
    const resultPerPage = [
        { value: 10, label: "10 items per page" },
        { value: 20, label: "20 items per page" },
        { value: 50, label: "50 items per page" },
        { value: 100, label: "100 items per page" },
        { value: 200, label: "200 items per page" },
    ];
    const [lengthOfPage, setLengthOfPage] = useState(() => {
        return JSON.parse(sessionStorage.getItem("bannerPerPage")) || resultPerPage[0]
    });

    useEffect(() => {
        sessionStorage.setItem("bannerPerPage", JSON.stringify(lengthOfPage));
    }, [lengthOfPage]);

    // Pagination logic
    const itemsPerPage = lengthOfPage?.value; // Show 10 items per page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const [inputSearch, setInputSearch] = useState();
    const handleSearch = (e) => {
        const get = e.target.value;
        setInputSearch(get);
        const search = list.filter((itm) => itm.otpSentOn && itm.otpSentOn.toLowerCase().includes(get.toLowerCase()))
        setFilterList(search);
        setCurrentPage(1);
    };
    const timeFormate = (time) => {
        try {
            // Check if the time is valid
            const date = new Date(time);
            if (isNaN(date)) {
                throw new Error("Invalid date");
            }

            const options = {
                day: 'numeric',    // 5
                month: 'numeric',    // Dec
                year: 'numeric',   // 2024
                hour: '2-digit',   // 10
                minute: '2-digit',
                hour12: true
            };

            const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
            return formattedDate;
        } catch (error) {
            console.error("Invalid time value:", error.message);
            return "Invalid Date";
        }
    };


    return (
        <>
            <div className="category">
                <div className="row">
                    <div className="category" style={{ display: "block" }}>
                        <div className="category-nav">
                            <div className="category-text">
                                <h4>OTP</h4>
                            </div>
                            <div className="category-btn">
                                <Select
                                    defaultValue={resultPerPage[0]}
                                    closeMenuOnSelect={true}
                                    name="colors"
                                    options={resultPerPage}
                                    value={lengthOfPage}
                                    onChange={(e) => { setLengthOfPage(e); setCurrentPage(1) }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />

                            </div>
                        </div>
                        <hr />
                        <div className="category-filter">
                            <div className="filterr">

                            </div>
                            <div className="search">
                                <h4>Search:</h4>
                                <input type="text" value={inputSearch} onChange={(e) => handleSearch(e)} placeholder="Search...." className="input" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="menu-table-container sticky-container-order">
                <div className="order-list">
                    <div className="order-list-header banner-list-header">
                        <div className="tittle">S.No.</div>
                        <div className='tittle'>Sent On</div>
                        <div className='tittle'>OTP Code</div>
                        <div className='tittle'>Created At</div>
                        <div className='tittle'>Expired At</div>
                        <div className='tittle'>Status</div>
                    </div>
                </div>
            </div>
            <div className="menu-table-container">
                <div className="order-list">

                    {
                        filterList?.slice(indexOfFirstItem, indexOfLastItem).map((item, index) => (
                            <div key={item.uuid} className='order-list-row banner-list-header'>
                                <div className="tittle">{indexOfFirstItem + index + 1}</div>
                                <div className='tittle'>{item.otpSentOn}</div>
                                <div className='tittle'>{item.otpCode}</div>
                                <div className='tittle'>{timeFormate(item.createdAt)}</div>
                                <div className='btn flex-btns'>
                                    {timeFormate(item?.expiredAt)}
                                </div>
                                <div className='tittle'>
                                    <button
                                        className={`status ${!item.expired ? 'active-btn' : 'inactive'}`}
                                    >
                                        {item.expired ? 'Expired' : 'Active'}
                                    </button>
                                </div>
                            </div>
                        ))
                    }

                    <div className="pagination">
                        <span>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filterList.length)} of {filterList.length} entries</span>
                        <span className="pagination-buttons">
                            <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalItem={filterList.length} lengthOfPage={lengthOfPage} />
                        </span>
                    </div>
                </div>
            </div >
        </>
    )
}
export default OtpController;